import {
  Box,
  Center,
  Flex,
  Image,
  useRadio,
  useRadioGroup,
} from '@chakra-ui/react';
import { MaterialModel } from 'lib/api/model';
import { useEffect } from 'react';

function RadioCardMaterial(props: any) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box w={props.buttonSize.w} h={props.buttonSize.h} position="relative">
      <Box as="label">
        <input {...input} />
        <Center
          {...checkbox}
          cursor="pointer"
          borderWidth="1px"
          borderRadius="md"
          boxShadow="md"
          _checked={{
            bg: '#f9fefb',
            color: 'black',
            borderWidth: '2px',
            borderColor: 'mint.500',
          }}
          h="56px"
          fontSize="14px"
          fontWeight={'medium'}>
          {props.children}
        </Center>
      </Box>
      {props.item.description !== '' && (
        <Box
          position={'absolute'}
          top={'-10px'}
          right={'-10px'}
          cursor={'pointer'}
          onClick={() =>
            props.onPressInfo(
              props.item.id,
              props.item.name,
              props.item.description_image,
              props.item.description_ratio,
              props.item.description
            )
          }>
          <Image src="/assets/images/icn_question.svg" />
        </Box>
      )}
    </Box>
  );
}

interface IRadioButtonsProps {
  radioGroupName: string;
  defaultValue?: string;
  buttonList: MaterialModel[];
  buttonSize: { w: string; h: string };
  onChange: (value: string) => void;
  infoDialog?: (
    id: number,
    title: string,
    image: string,
    ratio: number,
    description: string
  ) => void;
}
function RadioButtonsMaterial({
  radioGroupName,
  defaultValue = '',
  buttonList,
  buttonSize,
  onChange,
  infoDialog,
}: IRadioButtonsProps) {
  const { getRootProps, getRadioProps, setValue } = useRadioGroup({
    name: radioGroupName,
    defaultValue: defaultValue,
    onChange: onChange,
  });

  const group = getRootProps();

  useEffect(() => {
    setValue('');
  }, [buttonList, setValue]);

  return (
    <Flex {...group} gap="10px" flexWrap={'wrap'}>
      {buttonList.map((buttonValue, index) => {
        const radio = getRadioProps({ value: buttonValue.name });
        return (
          <RadioCardMaterial
            key={index}
            {...radio}
            buttonSize={buttonSize}
            item={buttonValue}
            onPressInfo={infoDialog}>
            {buttonValue.name}
          </RadioCardMaterial>
        );
      })}
    </Flex>
  );
}

export default RadioButtonsMaterial;
